import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty, throwErrorEvent } from '../lib/ep.js';

import { CreateButton, MainButton } from '../components/builder/ActionButton.js';
import ButtonCollection from '../components/builder/ButtonCollection';

import { NavigationTabsBuilder } from '../components/builder/NavigationTabs';
import SectionTitle from '../components/builder/SectionTitle.js';
import SectionSubtitle from '../components/builder/SectionSubtitle.js';

import { BuilderMainWithoutSidebar } from '../components/builder/BuilderMain.js';
import CardSelector from '../components/ui_items/CardSelector.js';
import { Route, HashRouter as Router, Switch,useParams} from 'react-router-dom';
import { MediaCandidates } from '../components/backend/MediaBuilder.js';
import FloatingLayer from '../components/builder/FloatingLayer.js';
import Model from '../components/builder/Model.js';
import Input from '../components/builder/Input.js';
import SaveButton from '../components/builder/SaveButton.js';
import Message from '../components/builder/Message.js';
import ActionLink from '../components/builder/ActionLink.js';
import { stage_promotion_types } from '../data/bootstrap_stages.js';

const StageCategory = (props) => {
	const { id } = useParams();
	const stage = props.categories.find((s) => s.Stage.id == id);

	const changeStage = (k, v) => {
		props.changeStage(id, k, v);
	};

	return (
		<MediaCandidates
			change={changeStage}
			intl={props.intl}
			isCorporate={true}
			nav_active={`/stages/categories/${id}`}
			nav_sections={[]}
			promotion={props.promotion}
			promoModel={props.promoModel}
			saveStage={(cb) => props.saveStage(id, cb)}
			deleteStage={props.deleteStage}
			stage={stage.Stage}
			stages={props.stages}
		/>
	)
}


const CategorySelector = ({ close, createCategory, createUserGenerated, ...props }) => {
	const i18n = (m) => i18nIntl(m, props.intl);

	const [ new_category, setNewCategory ] = useState(false);
	const [ category_type, setCategoryType ] = useState(false);
	const changeCategory = (k, v) => {
		setNewCategory({ ...new_category, [k]:v });
	};

	const types = [{
		type:'admin',
		icon:'knk-zipped',
		title:i18n("Admin Generated Content"),
		description:i18n("You as administrator will be the only one who upload the content or candidates to vote. Users won't be able to upload content to this category."),
		onClick:() => setCategoryType('admin'),
		extra_content:<ButtonCollection _class={{other:'gui_flex_center'}}>
			<MainButton>Create</MainButton>
		</ButtonCollection>,
	}, {
		type:'user',
		icon:'knk-user',
		title:i18n("User Generated Content"),
		description:`${i18n("Participants in the promotion will submit the content or candidates to vote. It is a User Generated Contest (UGC) and works great for contest with a nomination or submission phase. You, as admin, will be able to edit and moderate all submissions from participants. You can also add new entries to this category, if a user sends you content through any other channel.")}<br /><br />${i18n("We will create a new participation stage where you will be able to define the opening and closing dates and the number and format of submissions you allow.")}`,
		onClick:() => createUserGenerated(),
		extra_content:<ButtonCollection _class={{other:'gui_flex_center'}}>
			<MainButton>Create</MainButton>
		</ButtonCollection>,
	}];

	return (
		<FloatingLayer
			_class={{ size:(category_type == 'admin') ? 'small' : null }}
			backButton={close}
		>
			{(category_type == false) && (
				<div class="without_actions">
					<SectionTitle>Who will upload the candidates to vote to this category?</SectionTitle>

					<CardSelector
						items={types}
						_class='two_columned'
					/>
				</div>
			)}

			{(category_type == 'admin') && (
				<div>
					<SectionTitle>New category</SectionTitle>
					<SectionSubtitle>Usually a category will match to a voting gallery.</SectionSubtitle>

					<Model model={new_category} change={changeCategory}>
						<Input
							name='display_title'
							_class={{ size:60 }}
						>Category name</Input>
					</Model>

					<ButtonCollection in_floating={true}>
						<SaveButton
							onClick={()=>createCategory(new_category)}
						>Create</SaveButton>
					</ButtonCollection>
				</div>
			)}
		</FloatingLayer>
	)
}


const StageContentCategories = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ category_counters, setCategoryCounters ] = useState({});

	useEffect(() => {
		$.post(getRemotedbUrl(`/stages/content_counters/${props.promotion.id}`), (res) => {
			setCategoryCounters(res);
		},'JSON');
	}, []);

	const new_category_defaults = {
		display_title:"",
		media_colors:`rgba(255, 152, 0, 1)\nrgba(25, 164, 119, 1)`,
	};

	const [ new_category, setNewCategory ] = useState(false);

	const section_main_path = props?.section_main_path ?? 'stages';

	const changeCategory = (k, v) => {
		setNewCategory({ ...new_category, [k]:v });
	};

	const changeStage = (id, k, v) => {
		props.stagesStore.dispatch({ type:'CHANGE_STAGE', id, k, v });
	};

	const saveStage = (id,cb) => {
		const stages = props.stagesStore.getState();
		const stage = stages.stages.stages.find(s=>s.Stage.id == id );
		$.post(getRemotedbUrl(`/promotions/savestage/${stage.Stage.promotion_id}`), stage.Stage, (res) => {
			if(cb != undefined) cb();
			EP.showSuccessSave();
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});;
	};

	const createCategory = (new_category, cb) => {
		props.createStage({ id:45, data:new_category }, () => {
			setNewCategory(false);
			if(cb != undefined) cb();
		});
	};

	const createUserGenerated = (e, cb) => {
		props.createStage({ id:36}, () => {
			setNewCategory(false);
			if(cb != undefined) cb();
		});
	};



	const stage_candidates = [];
	stage_candidates.push(stage_promotion_types.MEDIA_CONTEST.id);//Multimedia Contest
	stage_candidates.push(stage_promotion_types.MEDIA_AUTOCONTENT.id);//Voting Contest
	stage_candidates.push(stage_promotion_types.PHOTOFUN.id);//Photofun
	stage_candidates.push(stage_promotion_types.SCENES.id);//Scenes

	const categories = props.stages.filter((s) => (stage_candidates.map(String).includes(String(s.Stage.promotion_type_id))));

	const is_wl = (props.promotion.promo_type == '2') ? true : false;
	const is_promotion_photofun = ([stage_promotion_types.PHOTOFUN.id,stage_promotion_types.SCENES.id].map(String).includes(String(props.promotion.promotion_type_id))) ? true : false;
	
	return (
		<Router hashType="noslash">
			<Switch>
				<Route exact={true} path={props.basePath}>
					<BuilderMainWithoutSidebar pm={props.promoModel} has_tabs={true}>
						<NavigationTabsBuilder active={`/${section_main_path}/categories`} sections={props.sections} />
						<section class="not_awesome">
							<div class="gui_section_header alone_section_header cleared_header">
								<SectionTitle _class={{other:'in_top'}}>Candidate management</SectionTitle>

								{(is_wl && !is_promotion_photofun) && (
									<ButtonCollection>
										<CreateButton
											onClick={(is_wl) ? () => setNewCategory(new_category_defaults) : null}
											disabled={(!is_wl) ? true : false}
										>New category</CreateButton>
									</ButtonCollection>
								)}
								
							</div>

							<SectionSubtitle autotranslate={false}>{i18n("Candidates to vote are organized into categories.")} {i18n("You can create a voting gallery for each category of candidates.")} {i18n("You must have at least 1 category.")} {i18n("A candidate must belong to a category, without exception.")}</SectionSubtitle>

							<CardSelector
								items={categories.map((item) => ({
									title:isNotEmpty(item.Stage, 'display_title') ? item.Stage.display_title : `${i18n("Category")} #${item.Stage.id}`,
									icon:'knk-folder',
									link:`#${section_main_path}/categories/${item.Stage.id}`,
									extra_content:category_counters[item.Stage.id] != undefined ? `${category_counters[item.Stage.id]} ${i18n("Candidates", 'lowercase')}`:undefined
								}))}
								_class='gui_not_in_top_big'
								style={{ maxHeight:'calc(100dvh - 280px)', overflow:'auto' }}
							/>

							{(!is_wl) && (
								<Message
									_class={{ other:'adaptative in_bottom' }}
								>
									<p><strong>{i18n("Premium promotions are limited to only one category of candidates.")}</strong></p>

									<p><ActionLink _href={`${window.zendesk_base_url}4403897289876`} _target='_blank'>Upgrade to the White Label version for a multi-category voting contest</ActionLink>.</p>
								</Message>
							)}
						</section>

						{new_category != false && (
							<CategorySelector 
								close = {() => setNewCategory(false)}
								createCategory={createCategory}
								createUserGenerated={createUserGenerated}
								intl={props.intl}
							/>
						)}


						{false && (new_category !== false) && (
							<FloatingLayer
								_class={{ size:'small' }}
								backButton={() => setNewCategory(false)}
							>
								<div>
									<SectionTitle>New category</SectionTitle>
									<SectionSubtitle>Usually a category will match to a voting gallery.</SectionSubtitle>

									<Model model={new_category} change={changeCategory}>
										<Input
											name='display_title'
											_class={{ size:60 }}
										>Category name</Input>
									</Model>

									<ButtonCollection in_floating={true}>
										<SaveButton
											onClick={createCategory}
										>Create</SaveButton>
									</ButtonCollection>
								</div>
							</FloatingLayer>
						)}
					</BuilderMainWithoutSidebar>
				</Route>

				<Route path={`${props.basePath}/:id`}>
					<StageCategory 
						categories={categories} 
						intl={props.intl}
						changeStage={changeStage}
						promotion={props.promotion}
						promoModel={props.promoModel}
						deleteStage={props.deleteStage}
						saveStage={saveStage}
						stages={props.stages}
					/>
				</Route>
			</Switch>
		</Router>
	);
}

export default injectIntl(StageContentCategories);